exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#task-team-selector .v-select,\n#task-team-selector .v-select * {\n  box-sizing: border-box;\n  line-height: 26px;\n  height: auto;\n}\n", ""]);

// exports
